// Paletas de cores e papéis de fundo prontos para a tela de Configurações.
//
// Paletas de cores são apenas um atalho de preenchimento: clicar nelas só
// chama updateSettings({ primaryColor, backgroundColor }) — os MESMOS dois
// campos que já existiam e já funcionavam via seletor de cor manual. Nenhum
// mecanismo novo de renderização é criado para elas.
//
// Papéis de fundo introduzem um novo campo (`wallpaperKey`) consumido via
// atributo `data-checklist-wallpaper` em AppShell + regras específicas no
// checklist.css. A opção "solido" (padrão) não tem regra CSS própria — ela
// deixa o gradiente atual (baseado em backgroundColor) intacto.

export const PALETAS_CORES = [
  { key: "azul-oficina", label: "Azul Oficina", primaryColor: "#2563eb", backgroundColor: "#2563eb" },
  { key: "grafite-industrial", label: "Grafite Industrial", primaryColor: "#475569", backgroundColor: "#475569" },
  { key: "verde-mecanica", label: "Verde Mecânica", primaryColor: "#16a34a", backgroundColor: "#16a34a" },
  { key: "laranja-pista", label: "Laranja Pista", primaryColor: "#ea580c", backgroundColor: "#ea580c" },
  { key: "vermelho-sport", label: "Vermelho Sport", primaryColor: "#dc2626", backgroundColor: "#dc2626" },
  { key: "roxo-premium", label: "Roxo Premium", primaryColor: "#7c3aed", backgroundColor: "#7c3aed" },
];

export const PAPEIS_FUNDO = [
  { key: "solido", label: "Sólido (padrão)", categoria: "padrao" },
  { key: "gradiente-azul", label: "Gradiente Azul", categoria: "gradiente" },
  { key: "gradiente-roxo", label: "Gradiente Roxo", categoria: "gradiente" },
  { key: "gradiente-laranja", label: "Gradiente Laranja", categoria: "gradiente" },
  { key: "textura-craquelado", label: "Craquelado", categoria: "textura" },
  { key: "textura-rustico", label: "Rústico", categoria: "textura" },
  { key: "textura-concreto", label: "Concreto", categoria: "textura" },
];

export const DEFAULT_WALLPAPER_KEY = "solido";
